/* eslint-disable */
export default {
  toolTip: '{crmName}で表示',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
